module.exports = "/images/bicicleteros.svg?66b0d64dc4b9d8fb709c472911764b39";